/**
 * Created by roi on 2/05/17.
 */
import { OBSERVACIO_SELECCIONADA, OBSERVACIO_INICIALITZAR } from '../../actions/actionTypes';

const ESTAT_INICIAL_DETALL = null;

const detall = (state = ESTAT_INICIAL_DETALL, action) => {

    switch (action.type) {
        case OBSERVACIO_SELECCIONADA:
            return action.codiEstacioObservacioSeleccionada;
        case OBSERVACIO_INICIALITZAR:
            return ESTAT_INICIAL_DETALL;
        default:
            return state;
    }
};

export default detall;



// WEBPACK FOOTER //
// ./src/reducers/observacio/detall.js